import {useState} from 'react';
import useData from '@/utils/useData';
import {Story} from 'entities/story';
import {StoryListType} from '@/types/StoryListType';

interface StoriesPaginatedResponse {
    items: Story[];
    pages: number[];
    count: number;
}

interface StoriesPaginatedReturn {
    stories: Story[];
    loading: boolean;
    error: any;
    pages: number[] | null;
    count: number;
    currentPage: number;
    setCurrentPage: (page: number) => void;
}

const useStoriesPaginatedData = (
    storyListType: StoryListType,
    searchQuery: string,
): StoriesPaginatedReturn => {
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pages, setPages] = useState<number[] | null>(null);
    const [count, setCount] = useState<number>(0);

    const [data, loading, , error] = useData<Story[]>(
        window.URLS.storiesResource,
        {
            storeResolver: 'stories',
            actionResolver: (actions: any) => (payload: any) => {
                const response = payload as StoriesPaginatedResponse | Story[];

                let items: Story[] = [];

                if (Array.isArray(response)) {
                    items = response;
                    setPages(null);
                    setCount(response.length);
                } else if (response && typeof response === 'object') {
                    items = response.items || [];
                    setPages(response.pages || null);
                    setCount(response.count || items.length);
                }

                if (actions.loadStories) {
                    actions.loadStories(items);
                } else if (actions.store) {
                    actions.store(items);
                }
            },
            dataResolver: (state: any) => state.items,
            initialValue: [],
            requestParams: {
                params: {
                    storyListType,
                    query: searchQuery,
                    page: currentPage,
                },
            },
        },
    );

    const stories = (data || []) as Story[];

    return {
        stories,
        loading,
        error,
        pages,
        count,
        currentPage,
        setCurrentPage,
    };
};

export default useStoriesPaginatedData;


